// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { Description } from '../../ProductHighlights/styles'
import { UnderlinedLink } from '../styles'

const digitalGiftCardLinkTo = '/products/figs-gift-card'

export const PhysicalText = () => {
  const { giftCard: strings } = useTranslation()
  return (
    <Description>
      {strings.lookingForDigital}{' '}
      <Link href={digitalGiftCardLinkTo}>
        <UnderlinedLink>{strings.here}</UnderlinedLink>
      </Link>
    </Description>
  )
}
